module.exports = __webpack_public_path__ + "static/chorus-6-570876a144135a235ad8d8ba4731aaae.png";